import { useMutation } from '@tanstack/react-query';
import type { JobChangeProcessBoardsMovePostRequest } from '../types/JobChangeProcessBoard';
import parseBoardResponse from './parseBoardResponse';

export default function usePostJobChangeProcessBoardsMove() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      job_change_process_id,
      target_board_id,
      order_number,
    }: JobChangeProcessBoardsMovePostRequest) => {
      const response = await fetch(`/agent/api/job_change_process_boards/move_job_change_process`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          job_change_process_id,
          target_board_id,
          order_number,
        }),
      });
      return parseBoardResponse(response, 'カードの移動に失敗しました');
    },
  });
}
